module.exports = __webpack_public_path__ + "img/part3-bg1.e57cd9fa.png";